/**
 * expo-constants, reduced to the two fields the app reads. The app version is
 * injected at build time by Vite (see vite.config.ts `define`) so feedback and
 * error reports still carry a real version instead of "unknown".
 */
declare const __APP_VERSION__: string;
declare const __APP_ENV__: string;

/**
 * What app.config.js used to put under `expo.extra`. Kept here rather than read
 * from a config file, because there is no Expo config in the Vite build and
 * these are the only two entries the app ever read.
 */
const extra = {
  posthog: {
    host: "https://eu.i.posthog.com",
  },
  appEnv: typeof __APP_ENV__ === "string" ? __APP_ENV__ : "dev",
};

const Constants = {
  expoConfig: {
    version: typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "0.0.0",
    extra,
  },
  deviceName: null as string | null,
};

export default Constants;
